<ng-content *ngIf="!isMobileView;then webMenu else mobileMenu">
    </ng-content>
<ng-template #webMenu>
<!-- ======= Header ======= -->
<header id="header" class="fixed-top header-transparent">
    <div class="container d-flex align-items-center justify-content-between">
      
        <div class="logo ">
            <a><img [src]="logoUrl" [alt]="companyName + ' Logo'" class="img-fluid"></a>
        </div>

        <nav id="navbar" class="navbar ">
          <div class="navbar_items">
            <ul>
                <li><a class="nav-link menu_links" routerLinkActive="active" [routerLink]="['/opportunities']">{{ 'Home.OPPORTUNITIES' | translate }}</a></li>
                <li><a class="nav-link menu_links" routerLinkActive="active" [routerLink]="['/investment']">{{ 'Home.INVESTMENTS' | translate }}</a></li>
                <li><a class="nav-link menu_links" routerLinkActive="active" [routerLink]="['/wallet']">{{ 'Home.WALLET' | translate }}</a></li>
                <li><a class="nav-link menu_links" routerLinkActive="active" [routerLink]="['/profile']">{{ 'Home.PROFILE' | translate }}</a></li>
              </ul>
            </div>
            <ul>
                <li><a class="nav-link cursor-pointer px-3" *ngIf="languageService.currentLanguage=='ar'" (click)="languageService.switchLang('en')">En</a></li>
                <li><a class="nav-link cursor-pointer px-3" *ngIf="languageService.currentLanguage=='en'" (click)="languageService.switchLang('ar')">Ar</a></li>
                <li>
                  <button mat-icon-button class="notification mx-2" [routerLink]="['/notifications/list']">
                    <span class="notification_dot" *ngIf="notificationService.unreadPushNotificationsCount>0"></span>
                    <i class="ri-notification-2-line"></i>
                  </button>
                </li>
                <li class="nav-item dropdown ms-3">
                    <a class="nav-link nav-profile d-flex flex-row align-items-center gap-2" data-bs-toggle="dropdown">
                      <div class="d-flex flex-column align-items-start">
                        <h6 class="mb-0" *ngIf="userService.currentUserCredantials.investTypeId==investTypes.Individual">{{'Home.INDIVIDUAL_INVESTOR' | translate }}</h6>
                        <h6 class="mb-0" *ngIf="userService.currentUserCredantials.investTypeId==investTypes.Company">{{'Home.COMPANY_INVESTOR' | translate }}</h6>           
                        <span class="d-none d-md-block dropdown-toggle font-weight-bold">
                          {{ languageService.currentLanguage === 'ar' ? userService.currentUserCredantials?.arabicName : userService.currentUserCredantials?.englishName }}
                        </span>
                      </div>
                    </a>
                    <ul (click)="openLogoutDialog()" class="cursor-pointer dropdown-menu dropdown-menu-start dropdown-menu-arrow profile">
                      <li>
                        <a class="dropdown-item d-flex align-items-center" >
                          <i class="bi bi-box-arrow-right"></i>
                          <span >{{'Home.SIGN_OUT'|translate}}</span>
                        </a>
                      </li>
          
                    </ul>
                  </li>
            </ul>
            <i class="bi bi-list mobile-nav-toggle"></i>
        </nav><!-- .navbar -->

    </div>
</header><!-- End Header -->
</ng-template>
<ng-template #mobileMenu>
    <header id="header" class=" header-transparent">
        <div class="container w-100 d-flex align-items-center justify-content-between mobile-header">
            <div class="logo ">
                <a><img [src]="logoUrl" [alt]="companyName + ' Logo'" class="img-fluid"></a>
            </div>
            <div class="d-flex align-items-center">
                   
                    
              <button mat-icon-button class="notification mx-3" [routerLink]="['/notifications/list']">
                <span class="notification_dot" *ngIf="notificationService.unreadPushNotificationsCount>0"></span>
                            <i class="ri-notification-2-line"></i>
                        </button>
                                           

                        <div class="nav-item dropdown cursor-pointer ms-2" mat-button [matMenuTriggerFor]="beforeMenuProfile">
                          <h6 class="mb-0 dropdown-toggle" *ngIf="userService.currentUserCredantials.investTypeId==investTypes.Individual">{{'Home.INDIVIDUAL_INVESTOR' | translate }}</h6>
                          <h6 class="mb-0 dropdown-toggle" *ngIf="userService.currentUserCredantials.investTypeId==investTypes.Company">{{'Home.COMPANY_INVESTOR' | translate }}</h6>
                        </div>
                        <mat-menu #beforeMenuProfile="matMenu" xPosition="before">                           
                            <a class="submenu-item" *ngIf="languageService.currentLanguage=='ar'" (click)="languageService.switchLang('en')"  mat-menu-item >
                              <i class="ri-global-line mx-3"></i>
                              <span>En  </span>
                            </a>
                            <a class="submenu-item" *ngIf="languageService.currentLanguage=='en'" (click)="languageService.switchLang('ar')"  mat-menu-item >
                              <i class="ri-global-line mx-3"></i>
                              <span>Ar  </span>
                            </a>
                            <a class="submenu-item" (click)="openLogoutDialog()"  mat-menu-item >
                                <i class="ri-logout-box-r-line mx-3"></i>
                                <span>{{'Home.SIGN_OUT'|translate}} </span>
                            </a>
                            </mat-menu>
                        
                   
                    
            </div>
        </div>

    </header>
    <div class="mobile-footer">
        <div class="d-flex w-100 p-2 justify-content-between align-items-center navbar">
          <a class="nav-link px-2" routerLinkActive="active" [routerLink]="['/opportunities']">{{ 'Home.OPPORTUNITIES' | translate }}</a>
          <a class="nav-link px-2" routerLinkActive="active" [routerLink]="['/investment']">{{ 'Home.INVESTMENTS' | translate }}</a>
          <a class="nav-link px-2" routerLinkActive="active" [routerLink]="['/wallet']">{{ 'Home.WALLET' | translate }}</a>
          <a class="nav-link px-2" routerLinkActive="active" [routerLink]="['/profile']">{{ 'Home.PROFILE' | translate }}</a>
        </div>
      </div>
      
</ng-template>
<ng-template #logoutTemplateRef>
    <div class="logout-content">
      <img src="../../../assets/images/Switches-bro 1.svg" class="logout-img">
      <p class="my-3 font-weight-700 font-size-4 dark-color">{{ 'Home.LOGOUT_CONFIRMATION' | translate }}</p>
      <p class="mb-4 font-weight-700 font-size-4 color-red">{{ 'Home.SIGN_OUT' | translate }}</p>
      
      <div class="mx-3 my-3 d-flex justify-content-between align-items-center">
        <button class="no-button" (click)="closeLogoutDialog()">{{ 'Home.NO' | translate }}</button>
        <button class="yes-button" (click)="logOut()">{{ 'Home.YES' | translate }}</button>
      </div>
    </div>
  </ng-template>
  